module.exports = __webpack_public_path__ + "img/yellowBrickBallone.287f5544.png";